
// export const MAINPHONE = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
export const MAINPHONE = /^1[3-9]\d{9}$/
export const TWNPHONE = /^[0][9]\d{8}$/ // 台湾
export const HKPHONE = /^(852)?(5[12345679]\d{6}|6\d{7}|9[0-8]\d{6})$/ // 香港
export const MACPHONE = /^(853)?6\d{7}$/ // 澳门
export const PHONE = /^\d+$/
